<template>
  <div
    class="m-page-main"
    :class="{
      'm-page-main--loading': loading,
      'm-page-main--center': center,
    }"
  >
    <slot />
  </div>
</template>

<script>
/**
 * The main content of the page. Should probably be wrapped in a `<main>` tag.
 */
export default {
  name: 'MPageMain',
  props: {
    /**
     * Set the whole main content to loading
     */
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Vertically center by not growing to fit
     */
    center: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.m-page-main {
  flex: 1 1 auto;
  height: auto;
  margin: auto;
  width: 100%;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex-shrink: 0;
  }

  &--loading {
    background: var(--skin-background-light);
    height: 100dvh;
    left: 0;
    opacity: 0.975;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 9999;
  }

  &--center {
    flex-grow: 0;
  }
}
</style>
